export { default } from './TitleTextButton';
export type { IPrismicTitleTextButtonPrimary } from './types';
